<template>
  <div class="enter-otp">
    <div class="r-text-headline-paragraph">מה הקוד שקיבלת בוואטסאפ?</div>
    <div class="r-form-row">
      <default-text-input
        :value="code"
        type="tel"
        label="קוד אימות"
        autofocus
        validations="required|digits:6"
        :serverErrorMessage="authenticationErrorMessage"
        @input="setCode"
        @observe="observe" />
    </div>
    <default-button label='הבא >' @click="authenticateAndProceed(code)" :loading="loading" :disable="loading"/>
    <link-button text="שלחו לי קוד חדש" @click="resendCode" class="resend-code text-center" display="block"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Segment from '@/Segment';
import TrackedPage from '@/mixins/TrackedPage';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import LinkButton from '@/components/base/LinkButton';
import GeneralErrorHandling from '@/mixins/GeneralErrorHandling';
import * as LoginApi from '@/api/LoginApi';

export default {
  name: 'EnterOtp',
  mixins: [TrackedPage, ValidationObserver, GeneralErrorHandling],
  components: { LinkButton, DefaultTextInput, DefaultButton },
  data() {
    return {
      code: '',
      loading: false,
      triedAutoConfirm: false,
      authenticationErrorMessage: undefined,
    };
  },
  props: {
    onValidOTP: {
      type: Function,
      required: true,
    },
    onRequiredFieldMissing: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState('authentication', ['phoneNumber']),
  },
  methods: {
    ...mapMutations('session', ['setAuthenticated']),
    setCode(code) {
      this.authenticationErrorMessage = undefined;
      this.code = code;
      if (!this.triedAutoConfirm && this.code.length === 6) {
        this.triedAutoConfirm = true;
        this.$nextTick(async () => {
          /**
           * We need to run the authentication only on next tick
           * so that the model of the input field is updated
           * and the validation on the field does not fire
           */
          await this.authenticateAndProceed(this.code);
        });
      }
    },
    async resendCode() {
      Segment.trackUserInteraction('Saving_ResendOtpClicked');
      this.authenticationErrorMessage = undefined;
      this.code = '';
      await LoginApi.generateCode({ phoneNumber: this.phoneNumber, force: true });
    },
    async authenticateAndProceed(code) {
      this.loading = true;
      try {
        const { valid } = await this.validate();
        if (valid) {
          Segment.trackUserInteraction('Saving_AuthenticateOtpClicked');
          const authenticateResult = await LoginApi.authenticate({ phoneNumber: this.phoneNumber, code });
          if (authenticateResult.status === LoginApi.STATUS.FAILURE) {
            await this._handleAuthenticationFailure(authenticateResult);
            return;
          }

          const { saverId, riseupAccountId } = authenticateResult.data;
          if (riseupAccountId) {
            this.setAuthenticated();
          }
          await this.onValidOTP({ saverId, riseupAccountId });
        }
      } finally {
        this.loading = false;
      }
    },
    async _handleAuthenticationFailure(authenticateResult) {
      switch (authenticateResult.errorType) {
        case LoginApi.ClientAuthenticationErrorTypes.REQUIRED_FIELD_MISSING:
          await this.onRequiredFieldMissing();
          break;
        case LoginApi.ClientAuthenticationErrorTypes.CODE_EXPIRED:
          Segment.trackUserInteraction('Saving_FESignup_CodeExpired');
          this.authenticationErrorMessage = 'הקוד פג תוקף, הזינו קוד חדש';
          break;
        case LoginApi.ClientAuthenticationErrorTypes.INVALID_CODE:
          Segment.trackUserInteraction('Saving_FESignup_InvalidCode');
          this.authenticationErrorMessage = 'הקוד שגוי';
          break;
        default:
          Segment.trackUserInteraction('Saving_AuthenticateOtp_GeneralError');
          this.logErrorAndShowDialog(authenticateResult.errorType);
      }
    },
  },
};
</script>
